// Posizionamento automatico delle scritte delle quote (coordinate in pixel schermo/canvas).
// Ogni scritta prova posizioni lungo la sua linea di quota; se occupate si sposta di lato con una linea di richiamo.
const hit = (a, b, pad) => Math.abs(a.x - b.x) * 2 < a.w + b.w + pad * 2 && Math.abs(a.y - b.y) * 2 < a.h + b.h + pad * 2;

// level > 1 = quota minore: viene nascosta (hidden) se la linea di quota è più corta della scritta o se non trova posto
export function placeLabels(items, fixed = [], pad = 2) {
  const placed = [...fixed];
  const order = items.map((it, i) => i).sort((a, b) => (items[a].level || 1) - (items[b].level || 1));
  const out = [];
  for (const i of order) out[i] = place(items[i], placed, pad);
  return out;
}

function place(it, placed, pad) {
  {
    const minor = (it.level || 1) > 1;
    const d = it.dir || [1, 0], L = Math.hypot(d[0], d[1]) || 1, ux = d[0] / L, uy = d[1] / L, nx = -uy, ny = ux;
    const along = Math.abs(ux) * it.w + Math.abs(uy) * it.h + 4, side = Math.abs(nx) * it.w + Math.abs(ny) * it.h + 4;
    if (minor && it.lineLen !== undefined && it.lineLen < along - 4) return { ...it, hidden: true };
    const lim = it.maxAlong ?? along * 3;
    const cands = [];
    for (const k of [0, 1, -1, 2, -2, 3, -3]) if (Math.abs(k * along * 0.6) <= lim) cands.push([ux * k * along * 0.6, uy * k * along * 0.6, false]);
    for (const k of [1.2, -1.2, 2.2, -2.2, 3.2, -3.2]) cands.push([nx * k * side, ny * k * side, true]);
    for (const [dx, dy, leader] of cands) {
      const box = { x: it.x + dx, y: it.y + dy, w: it.w, h: it.h };
      if (!placed.some((b) => hit(box, b, pad))) { placed.push(box); return { ...it, x: box.x, y: box.y, ax: it.x, ay: it.y, leader }; }
    }
    if (minor) return { ...it, hidden: true };
    placed.push({ x: it.x, y: it.y, w: it.w, h: it.h });
    return { ...it, ax: it.x, ay: it.y, leader: false };
  }
}
